namespace Areas.RequestAccess {
    "use strict";
    
    
    export function accessSaveForm() {

        var newData: any = $('#RequestForm').dxForm('instance').option('formData');
        var result: any = $("#RequestForm").dxForm("instance").validate();
     
        if (result.isValid) {
            saveForm("/RequestAccess/Request/Post", newData);
        }
    }
    
}